import React from 'react';
import { Row, Col } from 'reactstrap';
import ReactMapboxGl from "react-mapbox-gl";
import './Home.css';
import { Layer, Source, ScaleControl, ZoomControl } from 'react-mapbox-gl';
import Sidebar from './Sidebar';


const Map = ReactMapboxGl({
	accessToken: "pk.eyJ1IjoiY2FudXJiIiwiYSI6ImNqajBoNDkybzBodzIzdm1tNmpmYjZpZG4ifQ.9LnyyRrzdxZxS0A15rr-zw",
});

class Home extends React.Component {

	constructor(props) {
    super(props);

		this.state = {
			blockHighlightedID : 1
		};
  }
	
	handleMapClick = (map, e) => {
		this.props.onMapClick(map, e)
	}
		
	handleMapMouseMove = (map,e) => {
		const moveFeatures = map.queryRenderedFeatures(e.point);
		map.getCanvas().style.cursor = 'pointer';
		
		if (!moveFeatures.length || typeof moveFeatures[0].properties.BLOCKID === 'undefined') {
			map.getCanvas().style.cursor = ''
			this.setState({
				blockHighlightedID: 1
			})
      return;
    }

		this.setState({
			blockHighlightedID: moveFeatures[0].properties.BLOCKID
		})
	}
	
	handleMapZoomEnd = (map, e) => {
		this.props.onMapZoomEnd(map, e)
	}
	
	handleBuildingCategoryChange = (elems) => {
		this.props.onBuildingCategoryChange(elems)
	}

  render() {

    return (
			<Row className='Home-content mx-0'>
				<Col xs={12} md={7} lg={8} className='px-0 map-window'>
					<Map 
						style='mapbox://styles/canurb/cjivsm7k54yal2snxde14a4td'
						center={this.props.mapCenter}
						zoom={this.props.mapZoom}
						pitch={this.props.mapPitch}
						bearing={this.props.mapBearing}
						containerStyle = {{
							height: '100%'
						}}
						maxBounds={[-79.560, 43.5000, -79.2000, 43.7650]}
						onMouseMove={this.handleMapMouseMove}
						onClick={this.handleMapClick}
						onZoomEnd={this.handleMapZoomEnd}
					>
						{/* Controls */}
						<ScaleControl />
						<ZoomControl />
						<Source
							id='footprintSource'
							tileJsonSource={{
								'type': 'vector',
								'url': 'mapbox://canurb.66bmi61p'
							}}
						/>
						<Source
							id='blockSource'
							tileJsonSource={{
								'type': 'vector',
								'url': 'mapbox://canurb.0e4k0whd'
							}}
						/>
						<Source
							id='buildingSource'
							tileJsonSource={{
								'type': 'vector',
								'url': 'mapbox://canurb.5gfa9yqr'
							}}
						/>
						<Source
							id='maskSource'
							tileJsonSource={{
								'type': 'vector',
								'url': 'mapbox://canurb.3s95li47'
							}}
						/>							
						<Layer
							type='fill'
							minZoom = {10}
							maxZoom = {14}
							paint={{
								'fill-color': '#dddddd',
								'fill-opacity': 1,
							}}
							sourceLayer='Footprint_with_categories_201-36m59b'
							sourceId='footprintSource'
							before='road-label'
						/>			
						<Layer
							type='fill'
							minZoom = {10}
							maxZoom = {14}
							paint={{
								'fill-color': [
										'case',
										// matches building category
										['==', ['get','Category'], this.props.buildingCategory],
										'rgba(0,128,0,1)',									
										// does not match building category
										'rgba(0,128,0,0)',
									],
								'fill-opacity': 0.9,
							}}
							sourceLayer='Footprint_with_categories_201-36m59b'
							sourceId='footprintSource'
							before='road-label'
						/>							
						<Layer
							type='fill'
							paint={{
								'fill-color': [
										'case',
										// matches blockID
										['==', ['get','BLOCKID'], this.props.blockSelectedID],
										'rgba(0,128,0,1)',
										['==', ['get','BLOCKID'], this.state.blockHighlightedID],
										'rgba(204,204,0,1)',
										// does not match blockID
										'rgba(0,0,0,0)'
									],
								'fill-opacity': 0.2,
							}}
							sourceLayer='Block_Boundaries_20180628-8hxxv8'
							sourceId='blockSource'
						/>							
						<Layer
							type='line'
							paint={{
								'line-color': [
										'case',
										// matches blockID
										['==', ['get','BLOCKID'], this.props.blockSelectedID],
										'rgba(0,128,0,1)',
										['==', ['get','BLOCKID'], this.state.blockHighlightedID],
										'rgba(204,204,0,1)',
										// does not match blockID
										'rgba(0,0,0,0)'
									],
								'line-opacity': 0.6,
								'line-width': 5,
							}}
							sourceLayer='Block_Boundaries_20180628-8hxxv8'
							sourceId='blockSource'
						/>

						<Layer
							type='fill-extrusion'
							minZoom = {14}
							maxZoom = {22}
							paint={{
								'fill-extrusion-color': [
										'case',
										// matches blockID
										['==', ['get','BLOCKID'], this.props.blockSelectedID],
										'rgba(0,128,0,1)',
										// does not match blockID
										'rgba(229,225,220,0.9)'
									],
								'fill-extrusion-opacity': 0.8,
								'fill-extrusion-height': [
									'interpolate', ['linear'], ['zoom'],
									13, 60,
									13.55, ['get','AVG_HEIGHT']
													],		
								'fill-extrusion-base': [
									'interpolate', ['linear'], ['zoom'],
									13, 60,
									13.55, ['get','BASE']
													],
							}}
							light={{
									'anchor': 'viewport',
									'color': 'white',
									'intensity': 0.4
							}}
							sourceLayer='3D_Massing_with_Block_IDs_201-7ibyec'
							sourceId='buildingSource'
						/>								
						<Layer
							id='maskFill'
							type='fill'
							paint={{
								'fill-color': '#000000',
								'fill-opacity': 0.13,
							}}
							sourceLayer='Toronto_2030_District_Mask_20-bm0yi5'
							sourceId='maskSource'
							before='maskLine'
						/>
						<Layer
							id='maskLine'
							type='line'
							paint={{
								'line-color': 'rgba(0,128,0,1)',
								'line-opacity': 0.6,
								'line-width': 4,
							}}
							sourceLayer='Toronto_2030_District_Mask_20-bm0yi5'
							sourceId='maskSource'
							before='road-label'
						/>								
					</Map>
				</Col>
				<Col xs={12} md={5} lg={4} className='px-0 Sidebar'>
					<Sidebar 
						blockDetails = {this.props.blockDetails} 
						onbuildingCategoryChange = {this.handleBuildingCategoryChange} 
						buildingCategory = {this.props.buildingCategory}
						blockChartShow = {this.props.blockChartShow}
						zoomOut = {this.props.zoomOut}
					/>						
				</Col>
			</Row>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.js